import React, { useState } from 'react'
import { AlertTriangle, Save, Triangle } from 'react-feather';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { startEditCliente } from '../../../app/store/clientes/thunks';

export const CardDataCustomer = ({ data, variant }) => {

    /**
     * ToDo: Se renderizaran controles de acuerdo a la variante que se indique
     * - Falta enviar mensajes de validacion y validar formulario
     *  *-- data: Recibe la informacion del cliente en un objeto
     *  *-- Tendra opciones para editar y actualizar informacion del formulario
     * 
    */

    const reloadOption = 1;

    const { tiposClientes } = useSelector(state => state.catalogos);
    const dispatch = useDispatch();
    const [editMode, setEditMode] = useState(false);
    const { register, handleSubmit, reset } = useForm({
        defaultValues: {
            nombreCliente: data.NOMBRE,
            telefonoCliente: data.TELEFONO,
            celularCliente: data.CELULAR,
            emailCliente: data.EMAIL,
            tipoCliente: data.TIPO_CLIENTE,
            nacimientoCliente: data.FECHA_NAC
        }
    });

    const toggleEdit = () => {
        if (editMode) reset(data);
        setEditMode(prev => !prev);
    };

    const saveData = (formData) => {
        Swal.fire({
            title: 'Atención',
            text: "Está por Actualizar los datos del Cliente ¿Desea de continuar con esta acción?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3b7ddd',
            cancelButtonColor: '#dc3545',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
        }).then((result) => {
            if (result.isConfirmed) {

                const id = data.ID ?? data.CLIENTE_ID;

                dispatch(startEditCliente(formData, id, reloadOption))
            }
        })
        setEditMode(false);
    };

    return (
        <div className="card">
            <div className="card-header border-bottom d-flex justify-content-between align-items-center">
                <h5 className="card-title mb-0 text-black">Datos del Cliente: {data.ID || data.CLIENTE_ID}</h5>
                <button type="button" className="btn btn-outline-dark" onClick={toggleEdit} > {editMode ? "Cancelar" : "Editar"}
                </button>
            </div>
            <div className="card-body">
                {
                    !data.FECHA_NAC && (
                        <div className="alert alert-warning fw-bold text-justify" role="alert">
                            <AlertTriangle size={20} />
                            Este cliente no tiene la fecha de nacimiento registrada, favor de registrarla. Da clic en botón Editar y luego en Actualizar.
                        </div>
                    )
                }


                <form className='row' onSubmit={handleSubmit(saveData)}>
                    <div className='col-12 mb-2'>
                        <label className="form-label">Nombre:</label>
                        <input {...register('nombreCliente')} className="form-control" placeholder="Nombre cliente" disabled={!editMode} />
                    </div>
                    <div className='col-6 mb-2'>
                        <label className="form-label">Telefono:</label>
                        <input {...register('telefonoCliente')} className="form-control" placeholder="Teléfono" disabled={!editMode} />
                    </div>
                    <div className='col-6 mb-2'>
                        <label className="form-label">Celular:</label>
                        <input {...register('celularCliente')} className="form-control" placeholder="Celular" disabled={!editMode} />
                    </div>
                    <div className='col-12 mb-2'>
                        <label className="form-label">Correo:</label>
                        <input {...register('emailCliente')} className="form-control" placeholder="Correo electrónico" disabled={!editMode} />
                    </div>
                    <div className='col-6 mb-2'>
                        <label className="form-label"> F. Nacimiento: </label>
                        <input type="date" {...register('nacimientoCliente')} className="form-control" disabled={!editMode} />
                    </div>
                    <div className='col-6 mb-2'>
                        <label className="form-label" > Clasificación: </label>
                        <select className="form-select" {...register('tipoCliente')} disabled={!editMode}>

                            {
                                tiposClientes.map((item, index) => (
                                    item.ESTADO == 1 ? <option key={index} value={item.ID} className='text-uppercase' >{item.NOMBRE}</option>
                                        : <option key={index} style={{ display: "none" }} ></option>
                                ))
                            }
                        </select>
                    </div>
                    <div className='col-12 mb-2 text-end'>
                        <button type="submit" className="btn btn-outline-primary" disabled={!editMode} >  <Save size='20' />  Actualizar</button>
                    </div>

                    <div className='col-12 mb-2'>
                        <label className="form-label"> Membresía(s): </label><br />
                        <span> {data.MEMBRESIA}</span><br />
                    </div>
                </form>
            </div>
        </div>
    )



}
